<template lang="pug"> 
  nt-dialog(
    v-model='dialog'
    :title="$t('terms-of-use')"
    max-width="800"
    scrollable
  ) 
    v-card-text
      template(
        v-for='(item,index) in items', 
      )
        v-card-title(
          :key='index'
        )
          span {{ item.title }}
        v-card-text.mx-3
          div(v-html='item.description')
        v-divider.mx-3
      n-empty(v-if='items.length===0')  
    v-divider
    v-card-actions 
      v-spacer
      n-btn-submit(
        :block="false"
        @click='dialog = false'
      ) {{ $t('button.closed') }}

</template>
<script>
import { news as apiNews } from '@/apis'  

  export default { 
    data: () => ({
      dialog: false,
      items : [], 
    }), 
    methods : { 
      async open () { 
        await this.GAsidebar()
        this.dialog = true
      },

      async load () {
        let type = { type : 3 } 

        const [err,data ] = await apiNews.getNews(type)  
      
        if(err) { 
          return
        }    

        this.items = data 
      },
      
      async GAsidebar (){ 
        this.$ga.event('Button', 'SelectPage', 'SideBar', 'RuleMain' ) 
        this.load()
      }
    }
  }
</script>